module.exports = (state, action) => {
  const me = action.payload
  const meId = me.id
  if (meId !== undefined) {
    state.me = me
    state.logged = true
    return state
  } else {
    throw new Error('Error getting user information')
  }
}
